import Filter from '../../../components/Filter/Filter.jsx';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs.jsx';
import ApplicationsTable from '../../../components/ApplicationsTable/ApplicationsTable.jsx';

export default function RequestsCerts() {

    return <div className={'flex flex-column gap-3 w-full h-full'}>
        <Breadcrumbs />
        <Filter />
        <ApplicationsTable type={'Сертификаты'}/>
    </div>
}